<template>
  <main>
    <div>
      <gl-button @click="swapBaseAndCompare">
        対象・比較を入れ替える
      </gl-button>
    </div>
    <md-tabs
      :md-active-tab="activeTab"
      @md-changed="$emit('update:activeTab', $event)"
    >
      <md-tab id="base" md-label="対象">
        <filter-store v-bind.sync="base" :all="all" />
      </md-tab>
      <md-tab id="compare" md-label="比較">
        <filter-store v-bind.sync="compare" :all="all" />
      </md-tab>
    </md-tabs>
  </main>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
import FilterStore from '@/components/FilterStore.vue'

export default {
  components: { FilterStore },
  mixins: [ErrorReport],
  props: {
    /**
     * 店舗を企業権限に関係なしに全部取る
     */
    all: {
      type: Boolean,
      default: false,
    },
    /**
     * "対象"側の店舗
     */
    base: {
      storeGroup: {
        type: String,
      },
      stores: {
        type: Array,
        default: () => [],
      },
    },
    /**
     * "比較"側の店舗
     */
    compare: {
      storeGroup: {
        type: String,
      },
      stores: {
        type: Array,
        default: () => [],
      },
    },
    /**
     * 開いているタブ（基準 or 比較）
     */
    activeTab: {
      type: String,
      default: 'base',
      validator(v) {
        return ['base', 'compare'].includes(v)
      },
    },
  },
  methods: {
    swapBaseAndCompare() {
      this.$emit('update:base', {
        ...this.compare,
        storeGroup: this.compare.storeGroup,
        stores: this.compare.stores,
        key: new Date().getTime().toString(),
      })
      this.$emit('update:compare', {
        ...this.base,
        storeGroup: this.base.storeGroup,
        stores: this.base.stores,
        key: new Date().getTime().toString(),
      })
    },
  },
  computed: {
    errors() {
      const errors = []
      for (let error of this.base.errors) {
        errors.push('対象：' + error)
      }
      for (let error of this.compare.errors) {
        errors.push('比較：' + error)
      }

      return errors
    },
  },
}
</script>
